import { render, staticRenderFns } from "./_base-navbar.vue?vue&type=template&id=dd5f2c2c&scoped=true&"
import script from "./_base-navbar.vue?vue&type=script&lang=js&"
export * from "./_base-navbar.vue?vue&type=script&lang=js&"
import style0 from "./_base-navbar.vue?vue&type=style&index=0&id=dd5f2c2c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5f2c2c",
  null
  
)

export default component.exports